/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Onedata_Delete_Space_WarningInputs */



/**
* | output |
* | --- |
* | "This deletes the entire dataset space and every table and row it contains. This cannot be undone." |
*
* @param {Chat_Onedata_Delete_Space_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_onedata_delete_space_warning = /** @type {((inputs?: Chat_Onedata_Delete_Space_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Onedata_Delete_Space_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dies löscht den gesamten Datensatz-Space mit allen darin enthaltenen Tabellen und Zeilen. Dies kann nicht rückgängig gemacht werden.")
	return /** @type {LocalizedString} */ ("This deletes the entire dataset space and every table and row it contains. This cannot be undone.")
});